import React from 'react';
import { TooltipBox, TooltipContent, TooltipRow } from './style';

interface InfoTooltipProps {
  details: Record<string, string>;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ details }) => {
  const displayLabels: Record<string, string> = {
    fantasia: 'Fantasia',
    cnpj: 'CNPJ',
    contato: 'Contato',
    cidadeUf: 'Cidade/UF',
    telefone: 'Telefone',
    email: 'Email',
  };

  return (
    <TooltipBox>
      <TooltipContent>
        {Object.entries(details).map(([key, value]) => (
          displayLabels[key] && value && ( 
            <TooltipRow key={key}>
              <strong>{displayLabels[key]}:</strong> {String(value)}
            </TooltipRow>
          )
        ))}
      </TooltipContent>
    </TooltipBox>
  );
};

export default InfoTooltip;
